import { render } from "./DeleteVideo1.vue?vue&type=template&id=15e8b808"
import script from "./DeleteVideo1.vue?vue&type=script&lang=js"
export * from "./DeleteVideo1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__